export default __webpack_public_path__ + "static/notion-theme-2a06bae90f4cfa48d10e63fb1543084f.svg";